import { render, staticRenderFns } from "./gtfy.vue?vue&type=template&id=252ec013&scoped=true&"
import script from "./gtfy.vue?vue&type=script&lang=js&"
export * from "./gtfy.vue?vue&type=script&lang=js&"
import style0 from "./gtfy.vue?vue&type=style&index=0&id=252ec013&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252ec013",
  null
  
)

export default component.exports